import selectorSagas from './selectorSagas'
import cestaSagas from './cestaSagas'
import userSagas from './userSagas'
import searchSagas from './searchSagas'
import selectorMotoSagas from './selectorMotoSagas'
import searchMotoSagas from './searchMotoSagas'
import appSetupSagas from './appSetupSagas'
import areaPrivadaSagas from './areaPrivadaSagas'
import revisionSagas from './revisionSagas'
import { all } from 'redux-saga/effects'
import clientVehiclesSagas from './clientVehiclesSagas'
import aireAcondicionadoSagas from './aireAcondicionadoSagas'
import revisionMotoSagas from '../../../moto/revisiones/store/matricula/revisionMotoMatriculaSaga'
import revisionMotoMarcasSagas from '../../../moto/revisiones/store/marcas/revisionMotoMarcasSaga'
import revisionMotoModelosSagas from '../../../moto/revisiones/store/modelos/revisionMotoModelosSaga'
import revisionMotoLeadsSagas from '../../../moto/revisiones/store/lead/revisionMotoLeadSaga'
import catalogoListSaga from '../../../shared/catalogo/store/list/catalogoListSaga'
import catalogoFilterValuesSaga from '../../../shared/catalogo/store/filter/catalogoFilterValuesSaga'
import permutarNeumaticosSagas from '../../../coche/cita-previa/permutar-neumaticos/store/permutarNeumaticosSagas'
import watchMantenimientoSaga from '../../../shared/mantenimiento/store/mantenimientoSaga'
import citePreviaSagas from './citePreviaSagas'
import { vehiculoSaga } from '../../../coche/Neumaticos/Buscador/IdentificadorVehiculo/Infrastructure/store/vehiculoSaga'
import { medidasSaga } from '../../../coche/Neumaticos/Buscador/SeleccionMedidas/Infrastructure/store/medidasSaga'
import tallerSagas from '../../../coche/Neumaticos/Buscador/SeleccionTaller/Infrastructura/store/tallerSagas'
import { neumaticosCatalogPostSaga } from '../../../coche/Neumaticos/catalogo/utils/neumaticosCatalogPostSaga'
import { medidasMotoSaga } from '../../../moto/neumaticos/searchNeumaticosMoto/medidasMoto.saga'
import { filtrosMotoSaga } from '../../../moto/neumaticos/searchNeumaticosMoto/filtrosMoto.saga'

export default function* () {
  while (true) {
    yield all([
      selectorSagas(),
      cestaSagas(),
      userSagas(),
      searchSagas(),
      appSetupSagas(),
      selectorMotoSagas(),
      searchMotoSagas(),
      areaPrivadaSagas(),
      revisionSagas(),
      clientVehiclesSagas(),
      aireAcondicionadoSagas(),
      revisionMotoSagas(),
      revisionMotoMarcasSagas(),
      revisionMotoModelosSagas(),
      revisionMotoLeadsSagas(),
      catalogoListSaga(),
      catalogoFilterValuesSaga(),
      permutarNeumaticosSagas(),
      watchMantenimientoSaga(),
      citePreviaSagas(),
      vehiculoSaga(),
      medidasSaga(),
      tallerSagas(),
      neumaticosCatalogPostSaga(),
      medidasMotoSaga(),
      filtrosMotoSaga(),
    ])
  }
}
